import { Button } from "@nextui-org/react";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { usePathname } from "next/navigation";
import useStashwiseStore from "@/hooks/useStashwiseStore";

const Navbar = ({ page = "Download App" }) => {
  const { user, setOpenModal } = useStashwiseStore((state) => state);
  const pathName = usePathname();

  return (
    <div className="fixed top-0 left-0 mb-6 w-full bg-white flex text-white items-center justify-between px-6 md:px-20 py-6 shadow-md shadow-[rgba(0,0,0,0.09)] z-10">
      <Link href={`${Object.values(user).length > 0 ? "/dashboard" : "/"}`}>
        <Image src="/logo.png" alt="monietab Logo" width={120} height={50} />
      </Link>
      <Button
        onPress={() => setOpenModal("downloadMobile", true)}
        className={`${pathName.includes("student") ? "hidden" : "block"}  ${
          page === "Download App"
            ? "bg-transparent border-2 border-[#003471]"
            : "bg-[#0052D5] text-white"
        } px-10 md:px-12 hover:bg-opacity-80 hover:transition-all duration-300`}
      >
        {page}
      </Button>
    </div>
  );
};

export default Navbar;
